import { message, Modal } from "antd";
import { useState } from "react";
import { Notification } from "@/components";
import { ModelInputStyle } from "./style";
import { useSelector } from "react-redux";
import { spenToken } from "@/store";
import { Input } from "../Input";

interface PropType {
  callBack: () => void;
  handleOks: (
    val:
      | string
      | { value: string; value1: string; extraValue: string }
      | { value: string; extraValue: string },
  ) => void;
  title: string;
  type: number;
  msg?: string[];
  confirm?: string;
  two?: boolean;
}

const App = (props: PropType) => {
  const { callBack, title, handleOks, type, msg, confirm, two } = props;
  const [value, setValue] = useState("0.0001");
  const [value1, setValue1] = useState("0.0001");
  const [extraValue, setExtraValue] = useState("1");

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    type: number,
    field: "value" | "extra",
  ) => {
    const val = e.target.value;

    if (type === 1 && field === "value") {
      if (!/^\d*\.?\d*$/.test(val)) {
        return message.error("请输入正确数字");
      }
    }

    field === "value" ? setValue(val) : setExtraValue(val);
  };
  const handleChange1 = (
    e: React.ChangeEvent<HTMLInputElement>,
    type: number,
    field: "value" | "extra",
  ) => {
    const val = e.target.value;
    console.log("val::: ", val);

    if (type === 1 && field === "value") {
      if (!/^\d*\.?\d*$/.test(val)) {
        return message.error("请输入正确数字");
      }
    }
    console.log('field === "value"::: ', field === "value");

    field === "value" ? setValue1(val) : setExtraValue(val);
  };
  const handleOk = () => {
    // if (type === 1 && !account) {
    //   if (!extraValue) return Notification.Error('未连接钱包，输入框不能为空');
    // }

    if (type === 1) {
      if (!value) return Notification.Error("数量不能为空");
      if (!extraValue) return Notification.Error("滑点不能为空");
      if (two) {
        handleOks({ value, extraValue });
      } else {
        handleOks({ value, value1, extraValue });
      }
    }
    callBack();
  };

  const _spenToken = useSelector(spenToken);

  const handleCancel = () => {
    callBack();
  };
  const handleOverlayClick = () => handleCancel();
  const handleModalClick = (e: React.MouseEvent) => e.stopPropagation();
  return (
    <ModelInputStyle>
      <div className="custom-modal-overlay" onClick={handleOverlayClick}>
        <div className="custom-modal" onClick={handleModalClick}>
          <div className="custom-modal-header">
            <span>{title}</span>
            <button className="close-btn" onClick={handleCancel}>
              ×
            </button>
          </div>
          <div className="list">
            {msg &&
              msg.map((item, index) => (
                <div className="notice" key={index}>
                  {item}
                </div>
              ))}
          </div>

          {/* type === 1 时的额外输入框 */}
          {(type === 1 || type === 3) && (
            <div className="custom-modal-body">
              买入数量：
              <Input
                type="text"
                value={value}
                onChange={(e) => handleChange(e, 1, "value")}
                placeholder="0.1"
                className="custom-modal-input"
                style={{
                  marginRight: 10,
                }}
              />
              {!two && (
                <>
                  ~
                  <Input
                    type="text"
                    value={value1}
                    onChange={(e) => handleChange1(e, 1, "value")}
                    placeholder="0.1"
                    className="custom-modal-input"
                    style={{
                      marginRight: 10,
                      marginLeft: 10,
                    }}
                  />
                  {_spenToken.symbol}
                </>
              )}
            </div>
          )}
          {(type === 2 || type === 1) && (
            <div className="custom-modal-body">
              滑点：
              <Input
                type="text"
                value={extraValue}
                onChange={(e) => handleChange(e, type, "extra")}
                placeholder={"20"}
                className="custom-modal-input"
                style={{
                  marginRight: 10,
                }}
              />
              %
            </div>
          )}
          <div className="custom-modal-footer">
            <button className="btn btn-cancel" onClick={handleCancel}>
              取消
            </button>
            <button className="btn btn-ok" onClick={handleOk}>
              {confirm || "确定"}
            </button>
          </div>
        </div>
      </div>
    </ModelInputStyle>
  );
};

export default App;
